import { Typography } from '@shipengine/giger';
import { getCustomsSectionStyles, getCustomsSectionHeaderStyles, getCustomsSectionTypographyStyles } from './CustomsSectionStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

let CustomsSectionVariant = /*#__PURE__*/function (CustomsSectionVariant) {
  CustomsSectionVariant["SECTION"] = "section";
  CustomsSectionVariant["SUBSECTION"] = "subsection";
  return CustomsSectionVariant;
}({});
function CustomsSection(_ref) {
  let {
    title,
    children,
    variant = CustomsSectionVariant.SECTION,
    rightContent,
    parent: Parent = 'section',
    ...props
  } = _ref;
  const isMainSection = variant === CustomsSectionVariant.SECTION;
  return jsxs(Parent, {
    css: getCustomsSectionStyles,
    ...props,
    children: [jsxs("header", {
      css: getCustomsSectionHeaderStyles,
      children: [jsx(Typography, {
        css: getCustomsSectionTypographyStyles,
        variant: isMainSection ? 'subtitle2' : 'body2',
        component: isMainSection ? 'h3' : 'h4',
        bold: !isMainSection,
        children: title
      }), rightContent]
    }), jsx("div", {
      children: children
    })]
  });
}

export { CustomsSection, CustomsSectionVariant };
//# sourceMappingURL=CustomsSection.js.map
